import { c as _c } from "react/compiler-runtime";
import { CollectionLockup, CollectionLockupAvatar, CollectionLockupContent, CollectionLockupTitle } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { Item, ItemTitle } from "@opensea/next-ui-kit";
import { classNames, FlexCenter, StatChange, TextOverflowTooltip } from "@opensea/ui-kit";
import { CollectionLink } from "@/components/items/collection/CollectionLink";
import { TokenPrice } from "@/components/price/TokenPrice";
import { expandedSearchHoverStyles, expandedSearchSelectedStyles } from "./constants";
import { ExpandedSearch_collectionFragment } from "./ExpandedSearch.fragment";
export function ExpandedSearchTrendingCollectionCard(t0) {
  const $ = _c(23);
  const {
    collection: collectionKey,
    className,
    onSelect,
    selected: t1,
    onPointerEnter
  } = t0;
  const selected = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== collectionKey) {
    t2 = readFragment(ExpandedSearch_collectionFragment, collectionKey);
    $[0] = collectionKey;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const collection = t2;
  const t3 = selected && expandedSearchSelectedStyles;
  let t4;
  if ($[2] !== className || $[3] !== t3) {
    t4 = classNames("flex h-16 w-full items-center justify-center overflow-hidden rounded-lg border bg-bg-primary p-3 shadow-xs", expandedSearchHoverStyles, t3, className);
    $[2] = className;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CollectionLockupAvatar />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Item variant="unstyled"><TextOverflowTooltip><ItemTitle className="truncate"><CollectionLockupTitle className="text-sm" disableTextOverflowTooltip={true} /></ItemTitle></TextOverflowTooltip></Item>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== collection.floorPrice) {
    t7 = collection.floorPrice?.pricePerItem && <TokenPrice className="text-sm" price={collection.floorPrice.pricePerItem} valueColor="text-secondary" />;
    $[7] = collection.floorPrice;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== collection.stats) {
    t8 = collection.stats?.oneDay?.floorPriceChange !== undefined && collection.stats?.oneDay?.floorPriceChange !== 0 && <StatChange change={collection.stats.oneDay.floorPriceChange} className="text-sm" />;
    $[9] = collection.stats;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = <CollectionLockupContent className="min-w-0 flex-1 overflow-hidden">{t6}<FlexCenter className="gap-2">{t7}{t8}</FlexCenter></CollectionLockupContent>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== collection || $[15] !== t9) {
    t10 = <CollectionLockup collection={collection} size="md">{t5}{t9}</CollectionLockup>;
    $[14] = collection;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== collection || $[18] !== onPointerEnter || $[19] !== onSelect || $[20] !== t10 || $[21] !== t4) {
    t11 = <CollectionLink className={t4} collection={collection} onClick={onSelect} onPointerEnter={onPointerEnter}>{t10}</CollectionLink>;
    $[17] = collection;
    $[18] = onPointerEnter;
    $[19] = onSelect;
    $[20] = t10;
    $[21] = t4;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}